<template lang="pug">
    div
        div.sidebar(:class="showPage ? '' : 'sidebar-height'")
            div
                div(
                    v-if="showRouters && showRouters.length"
                    :class="['nav-container', navExpanding ? 'is-expanding' : 'is-collapse']"
                )
                    el-menu(
                        :unique-opened="false"
                        :default-active="navSelected"
                        :default-openeds="defaultOpeneds"
                        ref="navMenu"
                        class="nav-menu"
                    )
                        div(
                            v-for="one in showRouters"
                            :key="one.name"
                        )
                            //- 二级
                            el-submenu(
                                v-if="one.children && one.children.length && !onlyOneLevel.includes(one.name)"
                                :index="one.name"
                                :class="`nav-${one.name}`"
                            )
                                template(slot="title")
                                    div.nav-menu-item
                                        div.nav_icon
                                            svg-icon(
                                                :icon-class="one.name | toIconName(one.name === activeMenu)"
                                            )
                                        div.nav_title {{ one.title }}
                                div(v-if="one.children && one.children.length")
                                    div(
                                        v-for="two in one.children"
                                        :key="two.id"
                                    )
                                        //- el-menu-item-group(v-if="two.children && two.children.length && two.children[0].type !== 'BUTTON'")
                                        //-     template(slot="title")
                                        //-         div.nav_title {{ two.title }}
                                        //-     //- 三级
                                        //-     div(
                                        //-         v-for="(three,index) in two.children"
                                        //-         :key="index"
                                        //-     )
                                        //-         el-menu-item(
                                        //-             :index="three.name"
                                        //-             :route="{ name: three.name }"
                                        //-         )
                                        //-             div.nav_title {{ three.title }}
                                        //- 二级
                                        el-menu-item(
                                            v-if="two.type !== 'BUTTON' && two.name !== 'CollisionMessage'"
                                            :route="{ name: two.name }"
                                            :index="two.name"
                                            '@click'="routerLinkTo(two)"
                                        )
                                            div.nav_title {{ two.title }}
                            //- 一级
                            el-menu-item(
                                v-else
                                :index="one.name"
                                :route="{ name: one.name }"
                                :class="['nav-menu-item', `nav-${one.name}`]"
                                '@click'="routerLinkTo(one)"
                            )
                                div.nav_icon
                                    svg-icon(
                                        :icon-class="one.name | toIconName(one.name === activeMenu)"
                                    )
                                div.nav_title {{ one.title }}
            div.foot-container
                div.foot-container-user
                    el-tooltip(
                        effect="light"
                        placement="top-start"
                        content="账号设置"
                    )
                        el-popover(
                            placement="right"
                            trigger="click"
                            width="68"
                            popper-class="user-settings-popover"
                            :visible-arrow="false"
                            v-track="{ trackKey: 'nav_icon_click_icon', }"
                        )
                            div.click-list
                                span(
                                    @click="handelAccountSetting"
                                    v-track="{ trackKey: 'icon_account_setting_click_account_setting', }"
                                ) {{ $t('common.sideBar.accountSetting') }}
                                span(
                                    @click="handelModifyPassword"
                                    v-track="{ trackKey: 'icon_edit_password_click_edit_password', }"
                                ) {{ $t('common.sideBar.editPassword') }}
                                span(
                                    @click="handelModifyPhone"
                                    v-track="{ trackKey: 'icon_edit_phone_click_edit_phone', }"
                                ) {{ $t('common.sideBar.editPhone') }}
                                span.quit(
                                    @click="logout"
                                    v-track="{ trackKey: 'icon_log_out_click_log_out', }"
                                ) {{ $t('common.sideBar.logOut') }}
                            div.circle(slot="reference")
                                span {{ userInfo.name ? userInfo.name.substr(-2,2) : '--' }}
                div.foot-container-icons
                    div(
                        @click="sysSetting"
                        v-track="{ trackKey: 'nav_settings_click_settings', }"
                    )
                        el-tooltip(
                            effect="light"
                            content="系统设置"
                        )
                            svg-icon(
                                icon-class="setting-active"
                                className="svg-icon"
                            )
                    //- 多店模式隐藏此入口 v-if="userInfo.mode === 1"
                    div(
                        @click="messageNotify"
                    )
                        el-tooltip(
                            effect="light"
                            content="意见反馈"
                        )
                            svg-icon(
                                icon-class="message"
                                className="svg-icon"
                            )
                    div.help(
                        @click="helpCenter"
                        v-track="{ trackKey: 'nav_help_center_click_help_center', }"
                    )
                        el-tooltip(
                            effect="light"
                            content="帮助中心"
                        )
                            svg-icon(
                                icon-class="help"
                                className="svg-icon"
                            )
        modify-password(
            v-if="passwordData.show"
            :passwordData="passwordData"
        )
        modify-phone(
            v-if="phoneData.show"
            :phoneData="phoneData"
        )
        account-setting(
            v-if="accountSettingData.show"
            :accountSettingData="accountSettingData"
        )
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { handleParameter } from '@/filters';
import ModifyPassword from './ModifyPassword';
import ModifyPhone from './ModifyPhone';
import AccountSetting from './AccountSetting';

export default {
    name: 'Sidebar',
    props: {
        showPage: {
            type: Boolean,
            default: true,
        },
    },
    filters: {
        // 路由名转换为icon名
        toIconName(val, isActive) {
            let res = '';
            if (val) {
                res = `sidebar-${val.charAt(0).toLowerCase()}${val.substring(1)}`;
                // 激活状态的iconName
                if (isActive) res += '-active';
            }
            return res;
        },
    },
    computed: {
        ...mapState('permission', [
            'routers',
        ]),
        ...mapState('user', [
            'userMenuTree',
            'userMenuList',
            'userInfo',
            'moduleList',
        ]),
        navSelected() {
            return this.$route.matched[1].name;
        },
        // 激活的一级菜单name
        activeMenu() {
            if (!this.navSelected || !this.userMenuTree || !this.userMenuTree.length) return '';

            let res = '';
            // 根据name查找节点的父节点
            function searchParentNode(nodeList, name, parentNode) {
                let resNode = null;
                nodeList.some((node) => {
                    if (node.name === name) {
                        // parentNode不存在时代表自身作为一级菜单
                        resNode = parentNode || node;
                        return true;
                    }
                    // 前面的循环没有找到才继续向下找
                    if (!resNode) resNode = searchParentNode(node.children || [], name, node);
                    return false;
                });
                return resNode;
            }
            const routeNode = searchParentNode(this.userMenuTree, this.navSelected, null);
            if (routeNode && routeNode.name) res = routeNode.name;

            return res;
        },
    },
    components: {
        ModifyPassword,
        ModifyPhone,
        AccountSetting,
    },
    data() {
        return {
            passwordData: {},
            phoneData: {},
            accountSettingData: {},
            showRouters: [],
            // 导航栏是否展开
            navExpanding: true,
            defaultOpeneds: [],
            onlyOneLevel: [
                'Homepage',
                'FrequentLocations',
                'RadiationVehicles',
                'ArriveRemind',
                'VehicleEntry',
                'ShopSetting',
                'LabelManage',
                'LabelClassification',
                'SubsidyApply',
                'ShopManage',
                'GoodsManage',
                'InventoryManage',
                'OrderManage',
                'UsedCarCheck',
                'UsedCarVehicleManage',
                'VehicleInsuranceCluesList',
                'VehicleInsuranceList',
                'AutoInsuranceOrderList',
                'AutoInsurancePolicyList',
                'AutoInsuranceQuoteList',
            ],
        };
    },
    watch: {
        $route(n, o) {
            // navType改变重新读取左侧菜单数组
            if (n.query.navType !== o.query.navType) this.generateShowRouters();
        },
    },
    mounted() {
        this.generateShowRouters();
    },
    methods: {
        ...mapActions('user', [
            'GetJurisdiction',
        ]),
        ...mapActions('app', [
            'LogOut',
        ]),
        ...mapActions('user', [
            'LogOut',
        ]),
        handelAccountSetting() {
            this.accountSettingData = {
                userId: this.userInfo.id,
                name: this.userInfo.name,
                phone: this.userInfo.phone,
                username: this.userInfo.username,
                userCategory: this.userInfo.userCategory,
                roles: this.userInfo.roles,
                show: true,
            };
        },
        handelModifyPassword() {
            this.passwordData = {
                model: 'reset',
                userId: this.userInfo.id,
                show: true,
            };
        },
        handelModifyPhone() {
            this.phoneData = {
                userId: this.userInfo.id,
                show: true,
            };
        },
        logout() {
            this.LogOut();
        },
        /**
             * 通过navType读取左侧菜单值，刷新重新获取
             */
        generateShowRouters() {
            this.showRouters = [];
            const navType = this.$route.query.navType || 'Home';
            this.moduleList.forEach((val) => {
                if (val.name === navType) {
                    if (val.type === 'MODULE') {
                        this.showRouters = val.children || [];
                    } else {
                        this.showRouters = [
                            val,
                        ] || [];
                    }
                }
            });
            this.showRouters.forEach((val) => {
                if (val.children) this.defaultOpeneds.push(val.name);
            });
            // this.$nextTick(async () => {
            //     const navType = this.$route.query.navType || 'Homepage';
            //     if (!this.userMenuList || !this.userMenuList.length) await this.GetJurisdiction();

            //     this.showRouters = this.userMenuList[navType];
            //     if (this.showRouters && this.showRouters.length) {
            //         this.showRouters.forEach(val => {
            //             if (val.children && val.children.length) this.defaultOpeneds.push(val.name);
            //         });
            //     }
            // });
        },
        routerLinkTo(subitem) {
            handleParameter({
                trackKey: 'nav_left_click_left_nav',
                attr: {
                    parent_id: subitem.pid,
                    present_id: subitem.id,
                },
            });
            // if (!subitem.auth) {
            //     this.$message({
            //         type: 'warning',
            //         message: '暂未开通此模块权限，如有需要请向店铺管理员申请开通权限',
            //     });
            //     return;
            // }
            const { navType } = this.$route.query;
            // this.$router.push({
            //     name: 'AdList',
            //     query: {
            //         navType,
            //     },
            // });
            this.$router.push({
                name: subitem.name,
                query: {
                    navType,
                },
            });
        },
        // 系统设置菜单
        sysSetting() {
            const currentQuery = this.$route.query;
            this.$router.replace({
                query: {
                    ...currentQuery,
                    navType: 'Settings',
                },
            });
        },
        helpCenter() {
            this.$router.push({
                name: 'HelpCenter',
                query: {
                    navType: 'Home',
                },
            });
        },
        messageNotify() {
            this.$router.push({
                name: 'Feedback',
                query: {
                    navType: 'Feedback',
                },
            });
        },
    },
};
</script>
<style scoped lang="scss">
    .sidebar {
        overflow-y: auto;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index: 100;
        transition: width 0.3s;
        @include bg_color(color_base_white);
        box-shadow:1px 0px 10px 0px rgba(0, 0, 0, 0.07);
        .foot-container {
            margin: 0 20px 0px 20px;
            width: 159px;
            height: 140px;
            border-top: 1px solid;
            @include border_color(color_base_gray4);
            &-user {
                height: 88px;
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 20px;
                .circle {
                    height: 68px;
                    width: 68px;
                    border-radius: 34px;
                    @include bg_color(color_base_blue4);
                    @include font_color(text_color_white);
                    font-size: 22px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
            }
            &-icons {
                width: 100%;
                height: 23px;
                display: flex;
                justify-content: space-between;
                .svg-icon {
                    cursor: pointer;
                    width: 23px !important;
                    height: 23px !important;
                }
            }
        }
    }
    .sidebar-height {
        height: calc(100% - 80px);
    }
    .el-menu li {
        &.el-menu-item {
            display: flex;
            vertical-align: middle;
            align-items: center;
        }
        &.el-submenu {
            .nav-menu-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 40px;
            }
            .el-submenu__title {
                height: 40px;
                line-height: 40px;
                margin-top: 10px;
            }
        }
        .nav_icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            margin-right: 10px;
            > .svg-icon {
                width: 100%;
                height: 100%;
            }
        }
    }

    .nav-container {
        &.is-expanding {
            width: 200px;
            .el-submenu {
                .el-menu--inline {
                    top: 0 !important;
                }
            }
        }
        &.is-collapse {
            width: 72px;
            .nav_title, .nav-arrow {
                display: none;
            }
            .nav_icon {
                margin-right: 0 !important;
            }
            .el-submenu {
                position: relative;
                .el-menu--inline {
                    display: block;
                    width: 130px;
                    position: fixed;
                    top: 60px;
                    left: 82px;
                    z-index: 10000;
                    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                    @include border_color(color_base_gray5);
                    .nav_title, .nav-arrow {
                        display: block;
                    }
                    .el-menu-item {
                        width: 100%;
                        min-width: 0;
                        padding-left: 20px !important;
                    }
                }
            }
        }
    }
    .nav-menu {
        .el-menu-item {
            &.is-active {
                border-right-style: solid;
                border-right-width: 5px;
                @include border_color(color_base_blue6);
            }
        }
        .el-menu-item, .el-submenu__title {
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
        }
        .el-submenu__title {
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
        }
        .el-submenu__icon-arrow {
            display: none;
        }
        .el-submenu {
            .el-menu-item {
                padding-left: 58px !important;
            }
        }
        .el-menu-item,
        .el-submenu {
            .el-submenu__title {
                padding: 0;
            }
            .nav-arrow {
                position: absolute;
                right: 0;
                top: 14px;
                @include font_color(color_base_gray8);
                font-weight: 600;
                @include font_size(text_weak_annotation);
                transition: 0.3s;
                transform: rotateZ(90deg);
            }
            &.is-opened {
                .nav-arrow {
                    transform: rotateZ(270deg);
                }
            }
            &.is-active {
                .el-submenu__title {
                    @include font_color(text_color_primary);
                }
            }
        }
    }
    .user-settings-popover {
        margin: 0 !important;
        padding: 0 !important;
        .click-list {
            @include font_size(text_main_content);
            width: 120px;
            height: 160px;
            border-radius: 4px;
            @include bg_color(color_base_white);
            span {
                display: inline-block;
                width: 120px;
                height: 40px;
                padding: 10px 12px;
                line-height: 20px;
                @include font_color(text_color_black);
                cursor: pointer;
            }
            span.quit {
                @include font_color(text_color_error);
            }
            span:hover {
                @include bg_color(color_base_gray4);
            }
        }
    }
</style>
<style lang="scss">
    .user-settings-popover.el-popper {
        padding: 0 !important;
    }
    .user-settings-popover.el-popover {
        padding: 0 !important;
        min-width: 120px !important;
    }
    .sidebar{
        .el-menu-item, .el-submenu__title{
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
        }
    }
</style>
